export type CookieConsentStatus = 'accepted' | 'declined' | 'unset';

const COOKIE_CONSENT_KEY = 'sidego_cookie_consent';
const COOKIE_CONSENT_DATE_KEY = 'sidego_cookie_consent_date';

export const getCookieConsentStatus = (): CookieConsentStatus => {
    const value = localStorage.getItem(COOKIE_CONSENT_KEY);

    if (value === 'accepted' || value === 'declined') {
        return value;
    }

    return 'unset';
};

export const setCookieConsentStatus = (status: Exclude<CookieConsentStatus, 'unset'>): void => {
    localStorage.setItem(COOKIE_CONSENT_KEY, status);
    localStorage.setItem(COOKIE_CONSENT_DATE_KEY, new Date().toISOString());
};

export const hasOptionalCookieConsent = (): boolean => {
    return getCookieConsentStatus() === 'accepted';
};

export const clearKnownOptionalCookies = (): void => {
    const cookieNames = document.cookie
        .split(';')
        .map((cookie) => cookie.trim().split('=')[0])
        .filter(Boolean);

    const optionalCookiePrefixes = ['ph_phc_', 'dmn_chk_'];

    cookieNames.forEach((name) => {
        if (optionalCookiePrefixes.some((prefix) => name.startsWith(prefix))) {
            document.cookie = `${name}=; Max-Age=0; path=/; SameSite=Lax`;
        }
    });
};
